import { ReactNode } from 'react';

import { Cell, Pie, PieChart, PieProps } from 'recharts';

import { useTheme } from '@/hooks/useTheme';
import { ILoanUser } from '@/redux/loans/model';
import { cn } from '@/utils/helper';

interface IProps extends Pick<ILoanUser, 'nettyScore'> {
  width?: number;
  height?: number;
  outerRadius?: number;
  innerRadius?: number;
  children?: ReactNode;
  pieProps?: Pick<PieProps, 'outerRadius' | 'startAngle' | 'innerRadius' | 'cornerRadius' | 'paddingAngle'>;
  innerTextClassName?: string;
  className?: string;
}

const NettyScore: React.FC<IProps> = ({ nettyScore, width, height, pieProps, innerTextClassName, outerRadius, innerRadius, children, className }) => {
  const pieChartData = [
    { name: 'nettyscore', value: Number(nettyScore || 0) },
    { name: 'minus-nettyscore', value: 100 - Number(nettyScore || 0) },
  ];

  const { mode } = useTheme();

  return (
    <div className={cn('relative w-fit flex h-max self-center !bg-transparent [&_.recharts-wrapper]:!bg-transparent [&_path]:stroke-none', className ?? '')}>
      {children || <p className={cn('absolute w-fit inset-0 m-auto h-fit !bg-transparent text-[10px]/[0.7] font-bold text-coal-250 dark:text-white -bottom-[1px]', innerTextClassName)}>{nettyScore || 0}%</p>}
      <PieChart width={width || 32} height={height || 32} barGap={0}>
        <Pie data={pieChartData} dataKey='value' outerRadius={outerRadius || 15} startAngle={90} endAngle={-270} innerRadius={innerRadius || 13} cornerRadius={0} {...pieProps}>
          <Cell fill='#1160FF' />
          <Cell fill={mode === 'dark' ? '#333333' : '#E4E6F1'} />
        </Pie>
      </PieChart>
    </div>
  );
};
export default NettyScore;
